import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { URLS } from "../urls";
import { Form } from "react-bootstrap";
import moment from "moment";
import { fetchActionsUtil } from "../../utils";
import { toast } from "react-toastify";
import ModalLoader from "../ModalLoader";
import { DialogModal } from "../DialogModal";


export function EditAttendance({ show, handleClose, details, reload }, props) {
  const [isLoading, setIsLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [newStatus, setNewStatus] = useState("");


  const sendAction = async () => {
    try {
      setIsLoading(true);
      await fetchActionsUtil(`${URLS.backendattendance}/edit`, "POST", "", {
        ...details,
        date: moment(details.date).subtract(1,"day"),
        newStatus,
      });

      toast.success("Sucessful");
    } catch (error) {
      console.log(error);
      toast.error("Error !!! ", error.massage || "");
    } finally {
      setIsLoading(false);
      setOpenDialog(false);
      handleClose();
      reload();
    }
  };

  return (
    <Modal
      {...props}
      show={show}
      onHide={handleClose}
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Edit {details?.employeeName} Attendance</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="text-center">
          <div className="">
            <Form.Control
              as="select"
              value={newStatus}
              onChange={(e) => setNewStatus(e.target.value)}
              name="newStatus"
            >
              <option value="">Select new status</option>
              {["WeekOff", "Present", "Absent"].map((status) => {
                return <option value={status}>{status}</option>;
              })}
            </Form.Control>
          </div>

          <div className="my-4">
            <button
              onClick={() => setOpenDialog(true)}
              className="btn btn-primary"
            >
              Send
            </button>
          </div>
        </div>
      </Modal.Body>

      {openDialog && (
        <DialogModal
          show={openDialog}
          proceed={sendAction}
          handleClose={() => setOpenDialog(false)}
          title="Edit Attendance"
          description={`Are you sure you want to edit ${moment(
            details?.date
          )?.format("MMMM Do YYYY")} attendance of ${details?.employeeName}`}
          sendTitle="Proceed"
        />
      )}

      <ModalLoader show={isLoading} />
    </Modal>
  );
}
